import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { RichText } from "./RichText";

const hasText = (html) => !!(html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

export const Footer = ({ content }) => {
  const { t, L } = useLang();
  const left = (content && L(content, "footer_left")) || "";
  const copy = ((content && L(content, "footer_copyright")) || "").replace(/\{year\}/g, String(new Date().getFullYear()));
  return (
    <footer data-testid="site-footer" className="border-t border-[var(--vsl-border)] mt-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-14 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <img src="/logo-vessel.png" alt="VESSEL" className="h-8 mb-4 opacity-90" />
          {hasText(left) && (
            <RichText
              testid="footer-left-text"
              html={left}
              className="footer-rich font-mono text-xs tracking-[0.2em] uppercase text-[var(--vsl-muted)]"
            />
          )}
        </div>
        <div className="flex gap-10 font-mono text-xs tracking-[0.2em] uppercase h-fit">
          <Link to="/about" data-testid="footer-about" className="nav-link text-[var(--vsl-muted)] hover:text-[var(--vsl-fg)] transition-colors">{t("nav_about")}</Link>
          <Link to="/contacts" data-testid="footer-contacts" className="nav-link text-[var(--vsl-muted)] hover:text-[var(--vsl-fg)] transition-colors">{t("nav_contacts")}</Link>
        </div>
      </div>
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 pb-10 font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--vsl-muted)]">
        {hasText(copy) && (
          <RichText testid="footer-copyright" html={copy} className="footer-rich" />
        )}
      </div>
    </footer>
  );
};
